import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchBoxComponent } from './search/search.component';


export const DECLARATIONS = [
    SearchBoxComponent
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    declarations: [...DECLARATIONS],
    exports: [...DECLARATIONS],
    providers: [],
})
export class SearchBoxModule { }
